import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { ButtonSkeleton } from '@/components/shared/skeleton'

const TableSkeleton = () => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [ScreenSize.Xxs].includes(breakpoint)

  return (
    <>
      <div className="flex gap-12">
        <ButtonSkeleton width={20} height={20} />
        <ButtonSkeleton className="h-20 w-full" />
      </div>
      <div className="flex gap-12">
        <ButtonSkeleton width={20} height={20} />
        <ButtonSkeleton className="h-20 w-[133px]" />
      </div>
      <div className="flex gap-12">
        <ButtonSkeleton width={20} height={20} />
        <ButtonSkeleton className="h-20" width={isMobileScreen ? 238 : 341} />
      </div>
    </>
  )
}

export const InviteCreationSkeleton = () => (
  <div className="flex h-full flex-col justify-between px-40 md:px-24 xxs:px-16">
    <div className="flex flex-col gap-16">
      <div className="mb-16 flex flex-col gap-20 xxs:mb-20 xxs:mb-4">
        <ButtonSkeleton className="h-[56px] !w-full xxs:h-[44px]" />
        <ButtonSkeleton className="h-[56px] !w-full xxs:h-[44px]" />
      </div>
      <ButtonSkeleton className="h-[28px] w-[90px]" />
      <TableSkeleton />
      <TableSkeleton />
    </div>
    <ButtonSkeleton className="mb-40 h-[56px] w-full" />
  </div>
)
